import { IWorkForceUserEntity, TGeo } from "./globals";
import { Address, IProject } from "./project.interface";

export enum ProductType {
  Has_Quantity = "HAS_QUANTITY",
  Has_Sub_Product = "HAS_SUB_PRODUCT",
}

export enum ProductAction {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  ASSIGNED = "ASSIGNED",
}

export enum RequestStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
}

export enum SubProductStatus {
  AVAILABLE = "AVAILABLE",
  SENT_TO_SITE = "SENT_TO_SITE",
  ON_SITE = "ON_SITE",
  USED = "USED",
  DAMAGED = "DAMAGED",
  LOST = "LOST",
  UNDER_REPAIR = "UNDER_REPAIR",
}
export enum SubProductItemStatus {
  AVAILABLE = "AVAILABLE",
  USED = "USED",
  DAMAGED = "DAMAGED",
  LOST = "LOST",
  UNDER_REPAIR = "UNDER_REPAIR",
}
export const SubProductItemStatusList = [
  "AVAILABLE",
  "LOST",
  "USED",
  "DAMAGED",
  "UNDER_REPAIR",
];

export enum AdjustmentType {
  ADD = "ADD",
  REDUCE = "REDUCE",
}

export enum ProjectAssignToolsStatus {
  ONSITE = "ONSITE",
  AWAITING = "AWAITING",
  RETURN = "RETURN",
}

export enum ProjectToolStatus {
  AWAITING = "AWAITING",
  ONSITE = "ONSITE",
  REQUESTED_FOR_RETURN = "REQUESTED_FOR_RETURN",
  RETURNED = "RETURNED",
}

export enum ActivityActions {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  SET_REVISION = "SET_REVISION",
  SET_FINAL = "SET_FINAL",
  SET_NOT_FINAL = "SET_NOT_FINAL",
  STATUS_CHANGED = "STATUS_CHANGED",
  ASSIGNED = "ASSIGNED",
  APPROVED = "APPROVED",
}

export enum ProductRequestStatus {
  AWAITING = "AWAITING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum ToolStatus {
  AVAILABLE = "AVAILABLE",
  SENT_TO_SITE = "SENT_TO_SITE",
  ON_SITE = "ON_SITE",
  IN_REPAIR = "IN_REPAIR",
  DAMAGED = "DAMAGED",
  LOST = "LOST",
  USED = "USED",
}
export type TBase<T> = {
  isOpen: boolean;
  data: T;
};
export interface IProductLogsItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  leadsId: null;
  leadEstimatesId: null;
  userId: string;
  actor: IWorkForceUserEntity;
  activityEntity: string;
  detail: string;
  action: string;
  status: null;
  workDocketId: null;
  warehouseItemId: null;
  productId: string;
  subProductId: null;
  subProductItemId: null;
}

export interface SubProductsItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  productId: string;
  projectId: string;
  project: IProject;
  name: string;
  images: string[];
  files: string[];
  toolCount: null;
  availableItem: number;
  consumedItem: number;
  isConsumed: boolean;
  modelNumber: string;
  status: SubProductStatus;
  siteAssigned: TGeo;
  logs: IProductLogsItem[];
}

export interface ISubProduct {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  name: string;
  images: string[];
  files: string[];
  type: string;
  quantity: number;
  subProductCount: number;
  underRepair: number;
  onSite: number;
  consumed: number;
  subProducts: SubProductsItem[];
  modelNumber: string;
  logs: IProductLogsItem[];
}
export interface IProductOverView {
  available: number;
  consumed: number;
  sentToSite: number;
  onsite: number;
  repair: number;
}

export interface IProduct {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  name: string;
  images: string[];
  files: string[];
  type: ProductType;
  quantity: number;
  subProductCount: null;
  subProducts: SubProductsItem[];
  logs: IProductLogsItem[];
  project: IProject;
  _count: IProductOverView;
  productAssignments?: {
    project: IProject;
    assignedQuantity: number;
  }[];
}

export interface IProductConsumed {
  id: string;
  createdAt: Date;
  name: string;
  modelNumber: string | null;
  images: string[];
  type: string;
  status: ToolStatus;
  project: {
    id: string;
    name: string;
    address: Address;
  };
  logs: IProductLogsItem[];
}

export interface ISubProductAssignment {
  id: string;
  createdAt: string;
  updatedAt: string;
  subProductId: string;
  userId: string;
  status: string;
  productAssignmentId: string;
  project: IProject;
  subProduct: ISubProduct;
}
export interface ISubProductItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  subProductId: string;
  name: string;
  modelNumber: string;
  projectId: string;
  project: IProject;
  images: string[];
  siteAssigned: null;
  status: string;
  logs: IProductLogsItem[];
  SpecificSubProductAssignment: ISubProductAssignment;
}

interface IComment {
  id: string;
  createdAt: string;
  updatedAt: string;
  description: string;
  toolsId: string;
  userId: string;
  customerUserId: null;
  user: IWorkForceUserEntity;
  customerUser: IWorkForceUserEntity;
}
interface AssignedBy {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  image: string;
}

export interface IAssignTool {
  id: string;
  createdAt: string;
  updatedAt: string;
  projectId: string;
  productId: string;
  note: string;
  quantity: number;
  status: string;
  product: IProduct;
  subProducts: SubProductsItem[];
  logs: IProductLogsItem[];
  description: string;
  comments: IComment[];
  assignedBy: AssignedBy;
}

interface ProjectFrom {
  id: string;
  name: string;
}
interface ProjectTo {
  id: string;
  name: string;
}
interface TransferredBy {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  image: string;
}
export interface ITransferToolItems {
  id: string;
  product: IProduct;
  transferredQuantity: number;
  subProducts: SubProductsItem[];
}
export interface ITransferRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  projectToId: string;
  projectFromId: string;
  userId: string;
  projectFrom: ProjectFrom;
  projectTo: ProjectTo;
  transferredBy: TransferredBy;
  TransferToolItems: ITransferToolItems[];
}

interface Customer {
  id: string;
  name: string;
  shortName: string;
  logo: string;
}

export interface IAwaitingRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  status: string;
  beforeStatus: string;
  startDate: string;
  address: Address;
  radius: number;
  customerProjectReference: string;
  ourReferenceNumber: string;
  budgetHours: number;
  userAccessListId: null;
  customerId: string;
  customer: Customer;
  productAssignmentBatch: {
    _count: {
      productAssignments: number;
    };
  }[];
}

export interface IProductRequestDetail {
  id: string;
  requestId: string;
  createdAt: string;
  updatedAt: string;
  productId: string;
  quantity: number;
  remarks: string;
  product: {
    id: string;
    name: string;
    images: string[];
  };
}

export interface IProductRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  projectId: string;
  userId: string;
  remarks: string;
  status: string;
  requestedBy: IWorkForceUserEntity;
  project: IProject;
  items: IProductRequestDetail[];
}

export interface IReturnRequestItem {
  id: string;
  productRequestId: string;
  productAssignmentId: string;
  productId: string;
  quantity: number;
  projectAssignmentId: string;
  remarks: string;
  returnRequestId: string;
  product: IProduct;
  subProducts: SubProductsItem[];
}
export interface IReturnRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  workspaceId: string;
  projectId: string;
  userId: string;
  status: ProductRequestStatus;
  remarks: string;
  project: IProject;
  requestedBy: IWorkForceUserEntity;
  returnItems: IReturnRequestItem[];
}

export interface IProductsDetailsItem {
  id: string;
  productRequestId: null;
  projectToolId: string;
  returnRequestId: null;
  productId: string;
  quantity: number;
  remarks: null;
  note: string;
  description: string;
  product: IProduct;
  subProducts: SubProductsItem[];
}

export interface IProductAssignment {
  id: string;
  createdAt: string;
  updatedAt: string;
  productId: string;
  assignedQuantity: number;
  specificSubProductAssignmentId: string | null;
  userId: string;
  status: string;
  productAssignmentBatchId: string;
  note: string | null;
  requestItemId: string | null;
  subProductId: string | null;
  product: IProduct;
  subProductAssignments: ISubProductAssignment[];
  comments: IComment[];
  description: string;
  logs: IProductLogsItem[];
  assignedBy: AssignedBy;
}

export interface IProjectAssignedTool {
  id: string;
  createdAt: string;
  updatedAt: string;
  projectId: string;
  transferToolId: null;
  userId: string;
  subProductItemsList: null;
  note: string;
  description: string;
  quantity: number;
  status: string;
  returnStatus: string;
  remarks: null;
  returnRequestId: null;
  logs: IProductLogsItem[];
  comments: IComment[];
  assignedBy: AssignedBy;
  productAssignments: IProductAssignment[];
}
